import React from "react";
import { connect } from "react-redux";
import { PageTabs } from "../../../../../../store/AppDisplays";
import { Filter } from "../../../02-pages/Filter";
import { Invoices as InvoiceType } from "../../../../../../store/Invoice/Types";
import { isRemoteLoading, ReduxState } from "../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { Results } from "../../../02-pages/Results";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";

interface OwnProps {
    policyNumber: string;
}

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: InvoiceType;
}

type Props = OwnProps & StateProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.INVOICE_RESULTS),
    results:
            s.prop("remote").prop(RemoteScope.INVOICE_RESULTS),
});

/**
 *
 * @param props
 */
export class InvoicesComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
    }

    public render() {
        return (
            <Div style={{marginTop: "-20px"}}>
                <Filter
                    loadingFilters={this.props.loadingFilters}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.POLICIES_INVOICES}
                    defaultFilters={{
                        policyNumber: this.props.policyNumber,
                    }}
                />
                <Results
                    results={this.props.results}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.POLICIES_INVOICES}
                />
            </Div>
        );
    }
}

/**
 *
 */
export const Invoices = connect(
    mapStateToProps,
    {},
)(InvoicesComp);
